export const xPoems = (n: number): string => {
    if (n === 1 || (n % 10 === 1 && n % 100 !== 11)) {
        return 'песма';
    } else if ( n % 100 === 12 || n % 100 === 13 || n % 100 === 14 ) {
        return 'песама';
    } else if ( n % 10 === 2 || n % 10 === 3 || n % 10 === 4 ) {
        return 'песме';
    } else {
        return 'песама';
    }
}

export const xPoets = (n: number): string => {
    if (n === 1 || (n % 10 === 1 && n % 100 !== 11)) {
        return 'песник';
    } else {
        return 'песника';
    }
}

export const xCycles = (n: number): string => {
    if (n === 1 || (n % 10 === 1 && n % 100 !== 11)) {
        return 'циклус';
    } else {
        return 'циклуса';
    }
}